// extracted by mini-css-extract-plugin
export default {"labelHeight":"MKzwQA0Hqf5SI0iR3BXr"};